module.exports = __webpack_public_path__ + "img/maintop.4539b4d.png";